<template>
  <forgot-password-card />
</template>

<script>
import ForgotPasswordCard from '@/components/unauth/ForgotPasswordCard';

export default {
  name: 'ForgotPasswordView',
  components: {
    ForgotPasswordCard,
  },
};
</script>
